import { Input } from '@/components/ui/input';
import type { ContractSummaryFieldSchema } from './contract-summary-schema';

interface ContractSummaryFieldProps {
  field: ContractSummaryFieldSchema;
  value: unknown;
  onChange: (value: string | number) => void;
}

export function ContractSummaryField({ field, value, onChange }: ContractSummaryFieldProps) {
  const inputId = `contract-summary-${field.key}`;
  return (
    <tr className="border-t border-border align-top first:border-t-0">
      <td className="w-1/2 bg-muted/30 p-3">
        <label htmlFor={inputId} className="text-sm font-medium text-foreground">
          {field.label}
        </label>
        {field.description && (
          <div className="mt-2 space-y-1 text-xs leading-relaxed text-muted-foreground">
            {field.description.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
        )}
      </td>
      <td className="w-1/2 p-3">
        <Input
          id={inputId}
          type={field.inputType ?? 'text'}
          min={field.inputType === 'number' ? 0 : undefined}
          value={typeof value === 'string' || typeof value === 'number' ? value : ''}
          onChange={(event) => {
            if (field.inputType === 'number') {
              onChange(event.target.value === '' ? '' : event.target.valueAsNumber);
              return;
            }
            onChange(event.target.value);
          }}
        />
      </td>
    </tr>
  );
}
